export default "__VITE_ASSET__C80dNA9o__"